import React from 'react'
import { Row, Col, FormGroup, Label } from 'reactstrap'
import { Input } from 'dsm-react-lib'

const LoginAccountInputs = ({
  jobs,
  nameProfile,
  emailProfile,
  teamProfile,
  selectedJob,
  setTeamProfile,
  setSelectedJob
}) => {
  return (
    <>
      <Row>
        <Col md={6}>
          <FormGroup>
            <Label className="form-label" for="login-name">
              Name
            </Label>
            <Input type="text" id="login-name" value={nameProfile} disabled required />
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label className="form-label" for="login-email">
              Email address
            </Label>
            <Input type="email" id="login-email" value={emailProfile} disabled required />
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label className="form-label" for="role-team">
              What team do you belong to?
            </Label>
            <Input
              type="text"
              id="role-team"
              placeholder="Fund management ..."
              onChange={(e) => setTeamProfile(e.target.value)}
              value={teamProfile}
              data-testid={`loginTeamInput`}
              required
            />
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label className="form-label" for="job-user">
              What is your job function?
            </Label>
            <Input
              id="job-user"
              placeholder="Research"
              type="select"
              required
              onChange={(e) => setSelectedJob(jobs[e.target.value - 1])}
              value={selectedJob}
              data-testid={`loginJobInput`}>
              {jobs.length !== 0 &&
                jobs.map((item, index) => (
                  <option value={item.id} key={index}>
                    {item.name}
                  </option>
                ))}
              {jobs.length === 0 && <option value={-1}>No data ...</option>}
            </Input>
          </FormGroup>
        </Col>
      </Row>
    </>
  )
}

export default React.memo(LoginAccountInputs)
